export default () => ({
  height: null,
  swiper: null,
  isSlider: null,
  multipleMedia: null,
  rowIndex: null,
  rowIndexMobile: null,
  fullWidth: null,
  vertAlignment: null,
  isSliding: false,
  myActiveIndex: 0,
  slides: [],
  touchStartX: null,
  touchEndX: null,
  autoSlideTimer: null,

  initSlider(interval) {
    const slides = Array.from(document.querySelectorAll(".slider-hero-slide"));
    this.slides = slides;
    const slider = this.$refs.slider; // or your slider container element

    slider.addEventListener("touchstart", (e) => {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isDragging = false;
    });

    slider.addEventListener("touchmove", (e) => {
      this.touchEndX = e.touches[0].clientX;
      this.touchEndY = e.touches[0].clientY;

      const dx = Math.abs(this.touchEndX - this.touchStartX);
      const dy = Math.abs(this.touchEndY - this.touchStartY);

      // Only prevent default if the swipe is mostly horizontal
      if (dx > dy && dx > 10) {
        // 10px threshold to avoid accidental triggers
        e.preventDefault();
        this.isDragging = true;
      }
    });

    slider.addEventListener("touchend", () => {
      if (
        this.touchStartX !== null &&
        this.touchEndX !== null &&
        this.isDragging
      ) {
        const diff = this.touchStartX - this.touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.onNextButtonClick();
          } else {
            this.onPrevButtonClick();
          }
        }
      }
      this.touchStartX = null;
      this.touchEndX = null;
      this.touchStartY = null;
      this.touchEndY = null;
      this.isDragging = false;
    });

    if (interval && interval > 0) {
      this.startAutoSlide(interval);
    }
  },

  startAutoSlide(interval) {
    // Clear any existing timer
    if (this.autoSlideTimer) clearInterval(this.autoSlideTimer);

    // Start a new timer
    this.autoSlideTimer = setInterval(() => {
      this.slideNext();
    }, interval); // 4 seconds
  },

  stopAutoSlide() {
    if (this.autoSlideTimer) {
      clearInterval(this.autoSlideTimer);
      this.autoSlideTimer = null;
    }
  },

  onNextButtonClick() {
    this.stopAutoSlide();
    this.slideNext();
  },

  onPrevButtonClick() {
    this.stopAutoSlide();
    this.slidePrev();
  },

  slideNext() {
    if (this.isSliding) return;
    this.isSliding = true;
    const active = this.myActiveIndex;
    const slides = this.slides;
    const next = (active + 1) % slides.length;

    slides.forEach((slide, idx) => {
      const wrapper = slide.querySelector(".parallax-wrapper");
      if (wrapper) {
        wrapper.style.opacity = idx === active || idx === next ? "1" : "0";
        wrapper.style.transition = "none";
        wrapper.style.clipPath = "inset(0% 0% 0% 0%)";
        wrapper.style.transform = "translateX(0%) translateZ(0)";
      }
    });

    const nextWrapper = slides[next]?.querySelector(".parallax-wrapper");
    const currentWrapper = slides[active]?.querySelector(".parallax-wrapper");

    if (nextWrapper) {
      slides[next]?.classList.add("is-active");
      slides[active]?.classList.remove("is-active");
      nextWrapper.style.transition = "none";
      nextWrapper.style.clipPath = "inset(0% 50% 0% 50%)";
      nextWrapper.style.transform = "translateX(50%) translateZ(0)";
    }
    if (currentWrapper) {
      currentWrapper.style.transition = "none";
      currentWrapper.style.clipPath = "inset(0% 0% 0% 0%)";
      currentWrapper.style.transform = "translateX(0%) translateZ(0)";
    }

    if (nextWrapper) void nextWrapper.offsetWidth;
    if (currentWrapper) void currentWrapper.offsetWidth;

    const transition =
      "clip-path 1.2s cubic-bezier(0.35, 0, 0.15, 1), transform 1.2s cubic-bezier(0.35, 0, 0.15, 1)";
    if (nextWrapper) {
      nextWrapper.style.transition = transition;
      // EXAGGERATED OVERLAP: right edge extends 50% past the container
      nextWrapper.style.clipPath = "inset(0% -100% 0% 0%)";
      nextWrapper.style.transform = "translateX(0%) translateZ(0)";
    }
    if (currentWrapper) {
      currentWrapper.style.transition = transition;
      currentWrapper.style.clipPath = "inset(0% 50% 0% 50%)";
      currentWrapper.style.transform = "translateX(-50%) translateZ(0)";
    }

    setTimeout(() => {
      this.myActiveIndex = next;
      this.isSliding = false;
    }, 1200);
  },

  slidePrev() {
    if (this.isSliding) return;
    this.isSliding = true;
    const active = this.myActiveIndex;
    const slides = this.slides;
    const prev = (active - 1 + slides.length) % slides.length;

    // Show only active and prev slides, stack them
    slides.forEach((slide, idx) => {
      const wrapper = slide.querySelector(".parallax-wrapper");
      if (wrapper) {
        wrapper.style.opacity = idx === active || idx === prev ? "1" : "0";
        wrapper.style.transition = "none";
        wrapper.style.clipPath = "inset(0% 0% 0% 0%)";
        wrapper.style.transform = "translateX(0%) translateZ(0)";
      }
    });

    const prevWrapper = slides[prev]?.querySelector(".parallax-wrapper");
    const currentWrapper = slides[active]?.querySelector(".parallax-wrapper");

    // 1. Set initial states for both
    if (prevWrapper) {
      slides[prev]?.classList.add("is-active");
      slides[active]?.classList.remove("is-active");
      prevWrapper.style.transition = "none";
      prevWrapper.style.clipPath = "inset(0% 50% 0% 50%)";
      prevWrapper.style.transform = "translateX(-50%) translateZ(0)";
    }
    if (currentWrapper) {
      currentWrapper.style.transition = "none";
      currentWrapper.style.clipPath = "inset(0% 0% 0% 0%)";
      currentWrapper.style.transform = "translateX(0%) translateZ(0)";
    }

    // 2. Force reflow (on both, to ensure browser registers the initial state)
    if (prevWrapper) void prevWrapper.offsetWidth;
    if (currentWrapper) void currentWrapper.offsetWidth;

    // 3. Set transitions and animate both at the same time
    const transition =
      "clip-path 1.2s cubic-bezier(0.35, 0, 0.15, 1), transform 1.2s cubic-bezier(0.35, 0, 0.15, 1)";
    if (prevWrapper) {
      prevWrapper.style.transition = transition;
      // Exaggerated left overlap for incoming slide
      prevWrapper.style.clipPath = "inset(0% 0% 0% -100%)";
      prevWrapper.style.transform = "translateX(0%) translateZ(0)";
    }
    if (currentWrapper) {
      currentWrapper.style.transition = transition;
      currentWrapper.style.clipPath = "inset(0% 50% 0% 50%)";
      currentWrapper.style.transform = "translateX(50%) translateZ(0)";
    }

    // After animation, update own active index
    setTimeout(() => {
      this.myActiveIndex = prev;
      this.isSliding = false;
    }, 1200);
  }
});
